import { InternalProperty } from '@/features/property/types';
import { getCountryNameFromCode } from '@/utils';
import saveAs from 'file-saver';


export const exportPropertiesToExcel = async (
  properties: InternalProperty[],
  customFilename?: string
) => {
  // Dynamically import xlsx library to avoid bundling it if not used
  // @ts-ignore
  const XLSX = await import('xlsx');

  // Prepare data for export with explicit field mapping
  const exportData = properties.map(property => {
    // Create an object with explicit field mappings
    const exportObj: Record<string, any> = {
      'Property ID': property.property_id,
      'Property Name': property.name,
      'Country': getCountryNameFromCode(property.country_code),
      'Country Code': property.country_code,
      'Booking.com Path': property.path || '',
    };

    // Add metrics fields if available
    if (property.metrics) {
      exportObj['Rank'] = property.metrics.rank;
      exportObj['ADR'] = property.metrics.adr;
      exportObj['Review Score'] = property.metrics.review_score;
      exportObj['Availability'] = property.metrics.availability;
      exportObj['Search Views'] = property.metrics.search_views;
      exportObj['Property Views'] = property.metrics.property_views;
      exportObj['Booking Conversions'] = property.metrics.booking_conversions;
    }

    // Add compset metrics if available
    if (property.compset_metrics) {
      exportObj['Compset Rank'] = property.compset_metrics.rank;
      exportObj['Compset ADR'] = property.compset_metrics.adr;
      exportObj['Compset Review Score'] = property.compset_metrics.review_score;
      exportObj['Compset Availability'] = property.compset_metrics.availability;
    }

    return exportObj;
  });

  // Create workbook and worksheet
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Properties');

  // Generate Excel buffer
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  // Create Blob and save file
  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const filename = customFilename || `booking-dashboard-export-${new Date().toISOString().slice(0, 10)}`;

  saveAs(blob, `${filename}.xlsx`);
};